(function($) {
    $.widget("ca.caBoxSelect", {
        options: {
            disabled: false
        },

        _create: function() {
            var self = this;
            var select = this.element.closest('.ca-box-select');

            select.on('click', function(event) {
                event.stopPropagation();
                self.toggle(this);
            });

            select.find('.ca-box-select-row').on('click', function() {
                self.onSelect(this);
            });
            
            $('html').on('click', function () {
                $(this).find('.ca-box-select-options').slideUp(200);
            });
        },

        toggle: function (select)
        {
            if (!this.options.disabled) {
                $(select).find('.ca-box-select-options').slideToggle(200);
            }
        },

        onSelect: function(select)
        {
            var select = $(select);
            var id = select.data('id');
            var text = select.find('.ca-box-select-text').html();
            var comment = select.find('.ca-box-select-comment').html();

            var caption = select.closest('.ca-box-select').find('.ca-box-select-caption');
            caption.find('.ca-box-select-comment').html(comment);
            caption.find('.ca-box-select-text').html(text);

            select.closest('.ca-box-select-options').find('.ca-box-select-row').each(function() {
                $(this).removeClass('ca-box-select-selected');
            });

            select.addClass('ca-box-select-selected');

            $(this.element).val(id);

            this._trigger('onChange');
        }
    });
})(jQuery);